export default (params) => ({
  trigger: {
    name: 'top_navigation.select_category_in_top_navigation',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
    },
    event: {
      name: 'select_navigation',
      params: {
        sub_feature: null,
      },
    },
  },
});
